module.exports = __webpack_public_path__ + "static/media/analytices5.4095d26a.jpg";